/**
 * Investment comparables row
 */
export class InvestmentComparablesRow {
  /**
   * The OID
   */
  oid: number;

  /**
   * The transaction date
   */
  transactionDate: Date;

  /**
   * The size
   */
  size: number;

  /**
   * The vacancy
   */
  vacancy: number;

  /**
   * The tenant
   */
  tenant: string;

  /**
   * The passing rent
   */
  passingRent: number;

  /**
   * The price
   */
  price: number;

  /**
   * The multiplier
   */
  multiplier: number;

  /**
   * The price per area
   */
  pricePerArea: number;

  /**
   * The comment
   */
  comment: string;
}
